import axios from "axios"

export function getPackageDetail (uuid) {
  return new Promise((resolve, reject) => {
    axios.get(`/distributor/admin/api/v1/inventory/package/${uuid}`)
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  });
};